module.exports = __webpack_public_path__ + "media/d3.81282101.mp3";